module.exports = __webpack_public_path__ + "static/media/bf.170178c1.svg";